<template>
  <div class="collapsible-wrapper">
    <button
      id="collapsible-btn"
      @click="toggle"
      type="button"
      class="collapsible-btn"
      v-bind:class="{ open: toggleOpen }"
    >
      Koska kokeilu onnistuu?
    </button>
    <div id="collapsible-content" class="collapsible-content">
      <p>
        Sovi kokeiluaika ottamalla yhteyttä asiakaspalveluun puhelimitse tai sähköpostilla:
      </p>
      <ul>
        <li><a :href="'tel:' + getSelectedClub.contact.phone">{{ getSelectedClub.contact.phone_pretty }}</a></li>
        <li>
          <a :href="'mailto:' + getSelectedClub.contact.email + '?subject=' + encodeURIComponent(getSelectedClub.name + ' ilmainen kokeilu')">
            {{ getSelectedClub.contact.email }}
          </a>
        </li>
      </ul>
      <!-- <p class="title">{{ getSelectedClub.name }} - vastaanotto</p>
      <ul>
        <li v-for="hour in getSelectedClub.hours" :key="hour">{{ hour }}</li>
      </ul> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "InfoCollapsible",
  computed: mapGetters(["getSelectedClub"]),
  data: () => ({
    toggleOpen: false
  }),
  methods: {
    toggle() {
      this.toggleOpen = !this.toggleOpen;
      const toggleContent = document.getElementById("collapsible-content");
      if (toggleContent.style.maxHeight) toggleContent.style.maxHeight = null;
      else toggleContent.style.maxHeight = toggleContent.scrollHeight + "px";
    }
  }
};
</script>

<style scoped>
.collapsible-wrapper {
  margin: 2em 0;
  border-radius: 0;
}
.collapsible-btn {
  background: rgb(var(--vs-primary));
  color: #fff;
  cursor: pointer;
  padding: 18px;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  font-size: 15px;
  font-weight: bold;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
}
.collapsible-btn::after {
  content: "\002B";
  font-size: 15px;
  color: white;
  float: right;
  margin-left: 5px;
}
.collapsible-btn.open::after {
  content: "\2212";
}
.collapsible-content {
  padding: 0 1em;
  background: rgba(var(--vs-gray-4), 1);
  color: rgb(var(--vs-text));
  max-height: 0;
  overflow: hidden;
  -webkit-transition: max-height 0.2s ease-out;
  transition: max-height 0.2s ease-out;
  text-align: left;
}
.collapsible-content p {
  margin: 1em 0;
}
.collapsible-content ul {
  padding: 1em 0 1em 1.3em;
}
.collapsible-content ul li a {
  color: rgb(var(--vs-text));
}
p.title {
  font-weight: bold;
}
</style>
